<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';

const props = defineProps<{
  author: string
  // userName: string
}>()

const config = useRuntimeConfig();
const chatStore = useChatStore();
</script>

<template>
  <div class="flex gap-2 pl-3 items-center mb-3">
    <div class="">
      <img
        :src="props.author == 'me' ? chatStore.createUrl(true, 'images/icon_me.svg') : chatStore.createUrl(true, 'images/icon_bot.svg')"
        :alt="props.author == 'me' ? 'ユーザーアイコン 自分' : 'ユーザーアイコン ボット'" title="" />
    </div>
    <p class="font-bold text-base tracking-[1.6px]">{{ props.author == "me" ? "自分" : config.public.botName }}</p>
  </div>
</template>